export default "__VITE_ASSET__99d3a12e__"